import { render, staticRenderFns } from "./VerticalPornHub.vue?vue&type=template&id=0921b45a&scoped=true&"
import script from "./VerticalPornHub.vue?vue&type=script&lang=js&"
export * from "./VerticalPornHub.vue?vue&type=script&lang=js&"
import style0 from "./VerticalPornHub.vue?vue&type=style&index=0&id=0921b45a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0921b45a",
  null
  
)

export default component.exports